define(function(require, exports, module) {
    'use strict';

    // Передаются в модуль из fest/page/requirejs.config.js
    // Эквивалентно app.settings
    module.exports = process.env.SSR ? {} : window.cloudSettings || {};
});
